import { Edit, EditProps, SimpleFormProps } from 'react-admin';

import { DeleteConfirmation } from '@app/components/common/Table/DefaultTable/types';

import { DefaultForm } from '../DefaultForm';

interface ToolbarProps {
  resourceSingular: string;
  hideDelete?: boolean;
  onClose?(): void;
  customDiscardValidation?(): boolean;
  resolveDeleteConfirmation?(ctaId: number): Promise<DeleteConfirmation>;
}

export type EditViewProps = Omit<EditProps, 'children'> & SimpleFormProps & ToolbarProps;

export default function EditView({
  children,
  onClose,
  resourceSingular,
  hideDelete,
  validate,
  customDiscardValidation,
  resolveDeleteConfirmation,
  ...props
}: EditViewProps) {
  return (
    <Edit {...props}>
      <DefaultForm
        onClose={onClose}
        customDiscardValidation={customDiscardValidation}
        resolveDeleteConfirmation={resolveDeleteConfirmation}
        resourceSingular={resourceSingular}
        validate={validate}
        hideDelete={hideDelete}>
        {children}
      </DefaultForm>
    </Edit>
  );
}
